export default __webpack_public_path__ + "static/media/innovation-switch-web-rebrand.584d56b8.jpg";